module.exports = __webpack_public_path__ + "img/vn_qrcode_wechat.5c26874.jpg";